import { tableRowClasses } from '@mui/material/TableRow';
import { alpha } from '../../styles/color-manipulator';
export var createMuiTableRowOverrides = function (_a) {
    var _b, _c;
    var transitions = _a.transitions, tokens = _a.tokens;
    return {
        styleOverrides: {
            root: (_b = {
                    transition: transitions.create(['background-color'], {
                        duration: transitions.duration.shortest,
                    })
                },
                _b["&.".concat(tableRowClasses.hover, ":hover")] = {
                    backgroundColor: alpha(tokens.color_bg_interactive_hover, 0.5),
                },
                _b),
            head: (_c = {},
                _c["&.".concat(tableRowClasses.hover, ":hover")] = {
                    backgroundColor: 'transparent',
                },
                _c),
        },
    };
};
